import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ViewController,
  AlertController,
} from "ionic-angular";
import * as firebase from "firebase";
import { NodeService } from "../../services/node.service";
import { WalletService } from "../../services/wallet.service";
import { AppUtilities } from "../../app/app.utilities";
import { Store } from "@ngrx/store";
import { AppState } from "../../app/app.reducer";
import { User, Idol } from "../../app/app.models";
import { ConfigService } from "../../services/config.service";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../../services/auth.service";
import { WalletFetchAction } from "../../app/app.actions";
import { WatacardLoadingSerivce } from "../../services/watacard.loading.service";
import { WalletPage } from "../wallet/wallet";

@Component({
  selector: "page-fannel-detail",
  templateUrl: "fannel-detail.html",
})
export class FannelDetailPage {
  fannel: any;
  user$: User;
  idol: Idol;
  applicants: any[] = [];
  idiom: any;
  watacoins: number;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public walletservice: WalletService,
    private utilities: AppUtilities,
    public store: Store<AppState>,
    public viewCtrl: ViewController,
    private configService: ConfigService,
    private translateService: TranslateService,
    private authService: AuthService,
    public alertCtrl: AlertController,
    private nodeService: NodeService,
    private loadingService: WatacardLoadingSerivce
  ) {
    this.fannel = this.navParams.get("fannel");
    this.idol = this.navParams.get("idol");
    this.utilities.loading();
    this.user$ = this.authService.getUser();
    this.utilities.loadingDismiss();

    this.idiom = this.configService.getIdiom();
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad FannelDetailPage");
  }

  //PRODUCTION

  applyFanel() {
    //validamos que el applicante al fannel no sea el mismo ídolo que creo el fannel.
    if (this.fannel.address != this.walletservice.getAddress()) {
      var fannel: any;
      firebase
        .database()
        .ref(
          "prod_fannels/" + this.idol.address + "/fannel" + this.fannel.title
        )
        .once("value")
        .then((snapshot) => {
          if (snapshot.val()) {
            fannel = snapshot.val();
            var num;
            var fannelKeys = Object.keys(fannel);

            var fannelFilter = fannelKeys.filter((key) => {
              return key.includes("applicants");
            });

            num = fannelFilter.length + 1;

            var n = Date.now();
            if (!this.user$.photoURL) {
              this.user$.photoURL = "";
            }

            if (this.fannel.periode > n) {
              this.sendWatacoins().then((tx) => {
                firebase
                  .database()
                  .ref(
                    "prod_fannels/" +
                      this.idol.address +
                      "/fannel" +
                      fannel.title +
                      "/applicants" +
                      num
                  )
                  .set({
                    address: this.walletservice.getAddress(),
                    name: this.user$.displayName,
                    photoUrl: this.user$.photoURL,
                    uid: this.user$.uid,
                    txhash: tx,
                  });
                if (this.fannel.units == num && this.fannel.type === "speed") {
                  console.log("entrando en el close");
                  this.closeFannel();
                }
                this.viewCtrl.dismiss("applicants");
              });
            } else {
              //translate
              var fannel_time_finish = this.translateService.instant(
                "fannelDetail.fannel_time_finish"
              );
              this.utilities.alert(fannel_time_finish);
            }
          }
        });
    } else {
      var fannel_notApply = this.translateService.instant(
        "fannelDetail.fannel_notApply"
      );

      this.utilities.alert(fannel_notApply);
    }
  }

  alertMessageFannelPay() {
    var message =
      this.translateService.instant("fannelDetail.alert_pay_message1") +
      " " +
      this.configService.getAmount() +
      " " +
      this.translateService.instant("fannelDetail.alert_pay_message2");
    var cancelar = this.translateService.instant("CANCELAR");
    var aceptar = this.translateService.instant("ACEPTAR");

    const confirm = this.alertCtrl.create({
      message: message,
      inputs: [
        {
          name: "check",
          label: "Lo entiendo",
          type: "checkbox",
          value: "true",
        },
      ],
      buttons: [
        {
          text: cancelar,
          handler: () => {
            console.log("Disagree clicked");
          },
        },
        {
          text: aceptar,
          handler: (data) => {
            console.log("Agree clicked", data);
            if (data[0] === "true") this.validateFannelPay();
          },
        },
      ],
    });
    confirm.present();
  }

  validateFannelPay() {
    this.utilities.loading();
    this.nodeService
      .getBalanceWatacoins()
      .then((wallet) => {
        var wata: any = wallet.watacoins;
        this.watacoins = wata;
        console.log("Watacoins market " + this.watacoins);
        this.utilities.loadingDismiss();
        if (this.watacoins >= 1) {
          console.log("ok perfect");
          this.applyFanel();
        } else {
          this.alertBuyWatacoins();
        }
      })
      .catch((err) => {
        this.utilities.loadingDismiss();
        console.log("err");
      });
  }

  sendWatacoins() {
    return new Promise((resolve, reject) => {
      var address_to_send = this.configService.getAddressToSend();
      var amount = parseFloat(this.configService.getAmount());
      var send_ok = this.translateService.instant("walletsend.send_to_pay");
      this.nodeService
        .sendWatacoins(
          this.walletservice.getAddress(),
          address_to_send,
          amount * 1000000
        )
        .then(
          (tx: any) => {
            this.utilities.alert(send_ok);
            console.log("transacción enviada " + tx);
            this.loadingService.setTemp(tx, null, null);
            resolve(tx);
          },
          (error) => {
            var message = "Error: replacement transaction underpriced";
            this.utilities.alert(error);
            reject(message);
          }
        );
    });
  }

  alertBuyWatacoins() {
    var title = this.translateService.instant("fannelDetail.buy_wata_title");
    var message = this.translateService.instant(
      "fannelDetail.buy_wata_message"
    );
    var aceptar = this.translateService.instant("ACEPTAR");
    var cancelar = this.translateService.instant("CANCELAR");

    const confirm = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        {
          text: cancelar,
          handler: () => {
            console.log("Disagree clicked");
          },
        },
        {
          text: aceptar,
          handler: () => {
            this.viewCtrl.dismiss("wallet");
          },
        },
      ],
    });
    confirm.present();
  }

  //test
  /*
  applyFanel() {
    //validamos que el applicante al fannel no sea el mismo ídolo que creo el fannel.
    if (this.fannel.address != this.walletservice.getAddress()) {
      var fannel: any;
      firebase
        .database()
        .ref('fannels/' + this.idol.address + '/fannel' + this.fannel.title)
        .once('value')
        .then(snapshot => {
          if (snapshot.val()) {
            fannel = snapshot.val();
            var num = 1;
            while (fannel['applicants' + num]) {
              console.log(
                'Fannel Applicants ' + fannel['applicants' + num].name
              );
              num++;
            }
            var n = Date.now();
            if (this.fannel.periode > n) {
              firebase
                .database()
                .ref(
                  'fannels/' +
                    this.idol.address +
                    '/fannel' +
                    fannel.title +
                    '/applicants' +
                    num
                )
                .set({
                  address: this.walletservice.getAddress(),
                  name: this.user$.displayName,
                  photoUrl: this.user$.photoURL
                });
              if (this.fannel.units == num && this.fannel.type === 'speed') {
                console.log('entrando en el close');
                this.closeFannel();
              }
              this.viewCtrl.dismiss(true);
            } else {
              //translate
              var fannel_time_finish = this.translateService.instant(
                'fannelDetail.fannel_time_finish'
              );
              this.utilities.alert(fannel_time_finish);
            }
          }
        });
    }else {
      var fannel_notApply = this.translateService.instant(
        'fannelDetail.fannel_notApply'
      );

      this.utilities.alert(fannel_notApply);
    }
  }
*/
  cancel() {
    this.viewCtrl.dismiss(false);
  }

  //production

  closeFannel() {
    var date = Date.now();
    firebase
      .database()
      .ref("prod_fannels/" + this.idol.address + "/fannel" + this.fannel.title)
      .update({ periode: date });
  }

  //test
  /*
  closeFannel() {
    var date = Date.now();
    firebase
      .database()
      .ref('fannels/' + this.idol.address + '/fannel' + this.fannel.title)
      .update({ periode: date });
  }
  */
}



// WEBPACK FOOTER //
// ./src/pages/fannel-detail/fannel-detail.ts